export const gpsTable = [
  { percentile: 0.1, score: 34 },
  { percentile: 0.3, score: 35 },
  { percentile: 0.4, score: 36 },
  { percentile: 0.6, score: 37 },
  { percentile: 0.8, score: 38 },
  { percentile: 1.4, score: 39 },
  { percentile: 1.8, score: 40 },
  { percentile: 2.3, score: 41 },
  { percentile: 3.6, score: 42 },
  { percentile: 4.5, score: 43 },
  { percentile: 6.7, score: 44 },
  { percentile: 8.1, score: 45 },
  { percentile: 11.5, score: 46 },
  { percentile: 13.6, score: 47 },
  { percentile: 15.9, score: 48 },
  { percentile: 21.2, score: 49 },
  { percentile: 24.2, score: 50 },
  { percentile: 30.9, score: 51 },
  { percentile: 34.5, score: 52 },
  { percentile: 42.1, score: 53 },
  { percentile: 46, score: 54 },
  { percentile: 50, score: 55 },
  { percentile: 57.9, score: 56 },
  { percentile: 61.8, score: 57 },
  { percentile: 69.2, score: 58 },
  { percentile: 72.6, score: 59 },
  { percentile: 75.8, score: 60 },
  { percentile: 78.8, score: 61 },
  { percentile: 84.1, score: 62 },
  { percentile: 88.5, score: 63 },
  { percentile: 90.3, score: 64 },
  { percentile: 93.3, score: 65 },
  { percentile: 94.5, score: 66 },
  { percentile: 95.5, score: 67 },
  { percentile: 97.1, score: 68 },
  { percentile: 97.8, score: 69 },
  { percentile: 98.6, score: 70 },
  { percentile: 98.9, score: 71 },
  { percentile: 99.4, score: 72 },
  { percentile: 99.5, score: 73 },
  { percentile: 99.6, score: 74 },
  { percentile: 99.8, score: 75 },
  { percentile: 99.9, score: 76 }
]
